<template>
  <el-dialog :title="title" :visible.sync="dialogVisible" :width="width" v-if="dialogVisible">
    <div v-html="content"></div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handle('cancel')">取 消</el-button>
      <el-button type="primary" @click="handle('ok')">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: "提示"
    },
    width: {
      type: String,
      default: ""
    },
    content: {
      type: String,
      default: ""
    },
  },
  data() {
    return {
      dialogVisible: false,
      callback: null
    }
  },
  methods: {
    handle(action) {
      this.dialogVisible = false
      this.callback(action)
    }
  }
}
</script>
